import { Input as HeroInput } from '@heroui/react';
import React from 'react';

export interface FormInputProps {
  /** Input field ID */
  id: string;
  /** Input field name */
  name?: string;
  /** Input field label */
  label: string;
  /** Input field value */
  value?: string;
  /** Placeholder text */
  placeholder?: string;
  /** Input type */
  type?: 'text' | 'email' | 'tel' | 'password' | 'number' | 'url';
  /** Whether the field is required */
  required?: boolean;
  /** Whether the field is disabled */
  disabled?: boolean;
  /** Whether the field is invalid */
  isInvalid?: boolean;
  /** Error message to display */
  errorMessage?: string;
  /** Change handler */
  onChange?: (value: string) => void;
  /** Additional CSS classes */
  className?: string;
}

export const Input: React.FC<FormInputProps> = ({
  id,
  name,
  label,
  value,
  placeholder,
  type = 'text',
  required = false,
  disabled = false,
  isInvalid = false,
  errorMessage,
  onChange,
  className = '',
}) => {
  const inputClassNames = {
    input: 'text-foreground bg-transparent px-3 py-2',
    inputWrapper:
      'bg-default-50 border-default-200 hover:border-default-300 focus-within:border-primary shadow-sm hover:shadow-md transition-all duration-200',
  };

  return (
    <div className={`space-y-2 ${className}`}>
      <label htmlFor={id} className="text-sm font-medium text-foreground">
        {label}
      </label>
      <HeroInput
        id={id}
        name={name}
        value={value}
        placeholder={placeholder}
        type={type}
        variant="bordered"
        isDisabled={disabled}
        isInvalid={isInvalid}
        isRequired={required}
        errorMessage={errorMessage}
        onValueChange={onChange}
        classNames={inputClassNames}
      />
    </div>
  );
};
